import { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Coins, TrendingUp } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function DividendsYTDWidget({ currency }) {
  const [data, setData] = useState({ total_net: 0, total_gross: 0, dividends: [] });
  const [loading, setLoading] = useState(true);
  const year = new Date().getFullYear();

  useEffect(() => {
    let alive = true;
    setLoading(true);
    fetch(`${API}/dividends?currency=${currency}&year=${year}`, { credentials: 'include' })
      .then(r => r.ok ? r.json() : null)
      .then(j => { if (alive && j) setData(j); })
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, [currency, year]);

  const fmt = (n) => `${currency} ${Number(n || 0).toFixed(2)}`;
  const count = data.dividends?.length || 0;

  return (
    <Card data-testid="dividends-ytd-widget" className="border border-border mb-8">
      <CardContent className="py-5 px-6 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-md bg-amber-50 border border-amber-200 flex items-center justify-center">
            <Coins className="h-5 w-5 text-amber-700" strokeWidth={1.5} />
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.15em] text-muted-foreground">
              Dividends Received — YTD {year}
            </div>
            <div data-testid="ytd-dividends-net" className="text-2xl font-semibold tabular-nums">
              {loading ? "—" : fmt(data.total_net)}
            </div>
            {!loading && count > 0 && (
              <div className="text-xs text-muted-foreground mt-0.5">
                {count} payout{count > 1 ? 's' : ''} · Gross {fmt(data.total_gross)}
              </div>
            )}
          </div>
        </div>
        {!loading && count > 0 && (
          <div className="hidden sm:flex items-center text-success text-sm font-semibold">
            <TrendingUp className="h-4 w-4 mr-1" strokeWidth={1.5} />
            Passive Income
          </div>
        )}
      </CardContent>
    </Card>
  );
}

export default DividendsYTDWidget;
